// 导出基础 URL
const apiUrls = {
  // baseUrl: 'https://puki.vip/prod-api', //后端 API URL（8083端口）
   // adminUrl: 'https://puki.vip/admin'     // 后台管理页面 URL（3000端口）
  baseUrl: 'https://puki.vip/prod-api', // 设置基础 URL http://192.168.0.54:8083  测试： http://120.27.131.229:8083 
  // 生产： https://puki.vip/prod-api
  //本地：http://192.168.3.81:8083
  devApi: 'https://puki.vip/admin/prod-api' // 添加开发 API URL http://192.168.0.54/dev-api 测试: http://120.27.131.229:3000/prod-api
  //  生产： https://puki.vip/admin/prod-api
  //本地： http://192.168.3.81/dev-api
};

export default apiUrls;
